import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import Navigation from '../components/Navigation'

const bbbLogo = '../images/bbb-logo.png'
const facebook = '../images/facebook-icon.png'
const twitter = '../images/twitter-icon.png'
const insta = '../images/insta-icon.png'
const linkedin = '../images/linkedin-icon.png'
const lilogyco = '../images/LiloClean_LilogyCo.png'

const FooterView = ({ year }) => {
	return (
		<footer className="bg-lightgray text-texgray py-6 pb-12">
      <div className="">
        <Navigation link_cls="hover:text-darkazul" />
      </div>
      <div className="container px-4 lg:px-0">
        <div className="flex">
          <div className="w-full text-center">
            <p className="py-1">
              We believe teamwork makes the dream work. We all work together to make sure we provide outstanding customer service and an easy funding experience for you.
            </p>
            <p className="py-1 md:pb-12">
              &copy;{year} Lilogy All Rights Reserved
            </p>
          </div>
        </div>
        <div className="flex md:hidden justify-center">
          <div className="pb-12">
            <a href="https://www.lilogy.com" target="_blank" rel="noreferrer"><StaticImage height={48} width={231} src={lilogyco} alt="A Lilogy.com Company" /></a>
          </div>
        </div>
        <div className="flex justify-center">
          <div className="mr-4">
            <a href="https://www.facebook.com/liloclean" target="_blank" rel="noreferrer"><StaticImage height={32} width={32} src={facebook} alt="Facebook" /></a>
          </div>
          <div className="mr-4">
            <a href="https://twitter.com/LiIogy" target="_blank" rel="noreferrer"><StaticImage height={32} width={32} src={twitter} alt="Twitter" /></a>
          </div>
          <div className="mr-4">
            <a href="https://www.instagram.com/liloclean/" target="_blank" rel="noreferrer"><StaticImage height={32} width={32} src={insta} alt="Instagram" /></a>
          </div>
          <div className="mr-6">
            <a href="https://www.linkedin.com/company/lilogy/" target="_blank" rel="noreferrer"><StaticImage height={32} width={32} src={linkedin} alt="LinkedIn" /></a>
          </div>
          <div className="mr-4">
            <StaticImage src={bbbLogo} alt="BBB Logo" />
          </div>
          <div className="hidden md:block">
            <a href="https://www.lilogy.com" target="_blank" rel="noreferrer"><StaticImage height={48} width={231} src={lilogyco} alt="A Lilogy.com Company" /></a>
          </div>
        </div>
      </div>
    </footer>
	)
}

export default FooterView
